// Point d'entrée du mode factice. Importé en PREMIER par src/index.js, pour que l'adaptateur soit en place
// avant la création des clients axios. En production, la condition est fausse à la compilation : le code
// du mode factice (fixtures, mockAdapter) n'entre pas dans le bundle.
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_ADMIN_MOCK === "1") {
  // eslint-disable-next-line global-require
  require("./mockAdapter").installMock();
}
